import React, { useState, useRef, useEffect } from "react"
import { BookOpen } from "lucide-react"
import { Typography, Button, Badge, Input, message, useCRUDController, Row, Col, Card, Select, Divider } from "../../ui/ot"
import dayjs from 'dayjs';
import { BadgeInfo } from 'lucide-react';
import { ChartCirculationStatscard } from "./chart_circulation_statscard"
import { ChartCategoryBorrowStatistics } from './chart_category_borrow_statistics'
import { ChartCategoryBorrowRatio } from './chart_category_borrow_ratio'
import { ChartCategoryMonthlyTrend } from './chart_category_monthly_trend'
import { TableCategoryCirculationDetails } from './table_category_circulation_details'
const basicFilterSetting = ["branchcode", 'itemtype']

const CirculationTrendAnalysis = ({
    filterSearchParams = [...basicFilterSetting]

}) => {
    const [searchParams, setSearchParams] = useState({
        item_type: null,
        branchcode: null,
        keyword: null
    })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const itemtypeController = useCRUDController({ apiRoute: "/koha/itemtypes" })
    useEffect(() => {
        libraryController.getData({})
        itemtypeController.getData({})
    }, []);
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <Row align="middle">
                <Col>
                    <BookOpen className="h-5 w-5" />
                </Col>
                <Col>
                    <Typography.Title level={4}>
                        分類流通統計報表
                    </Typography.Title>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                <Col span={24}>
                    <Row >
                        {filterSearchParams.includes("branchcode") ? <Col>
                            <Row align={"middle"} gutter={[8, 8]}>
                                <Col>
                                    分館篩選：
                                </Col>
                                <Col>
                                    <Select
                                        allowClear={true}
                                        defaultValue={searchParams?.branchcode}
                                        value={searchParams?.branchcode}
                                        onChange={(value) => {
                                            setSearchParams((pre) => {
                                                return {
                                                    ...pre,
                                                    branchcode: value
                                                }
                                            })
                                        }}
                                        options={libraryController?.ResponseData?.map((option) => {
                                            return {
                                                label: `(${option?.branchcode})${option?.branchname}`,
                                                value: option?.branchcode,
                                            }
                                        })}
                                    >
                                    </Select>
                                </Col>
                            </Row>
                        </Col> : <></>}
                        {filterSearchParams.includes("itemtype") ? <Col>
                            <Row align={"middle"} gutter={[8, 8]}>
                                <Col>
                                    館藏分類篩選：
                                </Col>
                                <Col>
                                    <Select
                                        allowClear={true}
                                        defaultValue={searchParams?.itemtype}
                                        value={searchParams?.itemtype}
                                        onChange={(value) => {
                                            setSearchParams((pre) => {
                                                return {
                                                    ...pre,
                                                    item_type: value
                                                }
                                            })
                                        }}
                                        options={itemtypeController?.ResponseData?.map((option) => {
                                            return {
                                                label: `(${option?.itemtype})${option?.description}`,
                                                value: option?.itemtype,
                                            }
                                        })}
                                    >
                                    </Select>
                                </Col>
                            </Row>
                        </Col> : <></>}
                    </Row>
                </Col>
                <Col span={24}>
                    <Row align="middle" gutter={[4, 4]}>
                        <Col>
                            <BadgeInfo size={16} />
                        </Col>
                        <Col>
                            <Typography.P>
                                各圖書分類的借閱統計與趨勢分析
                            </Typography.P>
                        </Col>
                    </Row>
                </Col>
                <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={24}>
                    <ChartCirculationStatscard
                        propsDataParams={{
                            ...searchParams
                        }}
                        apiRoute="/koha/report/circulation/item_type/total"
                        propsLabel="圖書分類數"
                        rowKey="item_type_number"
                    />

                </Col>
                <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={24}>
                    <ChartCirculationStatscard
                        propsDataParams={{
                            ...searchParams
                        }}
                        apiRoute="/koha/report/circulation/item_type/popular"
                        rowKey="percent"
                        propsColor="#f09a45"
                        getLabel={(data) => {
                            return `最熱門分類:${data?.description}佔比`
                        }}
                    />
                </Col>
                <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={24}>
                    <ChartCirculationStatscard
                        propsDataParams={{
                            ...searchParams
                        }}
                        apiRoute="/koha/report/circulation/total"
                        rowKey="circulation_total"
                        getLabel={(data) => {
                            return `總流通量(本月累計)`
                        }}
                    />
                </Col>
                <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={24}>
                    <ChartCirculationStatscard
                        propsDataParams={{
                            ...searchParams
                        }}
                        apiRoute="/koha/report/circulation/growth_rate"
                        propsLabel="成長率(較上月)"
                        rowKey="growth_rate"
                        propsColor="#f09a45"
                    />
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    <Card
                        title={"分類借閱統計"}
                        extra={"各分類的借閱與歸還數量對比"}
                    >
                        <ChartCategoryBorrowStatistics />
                    </Card>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    <Card
                        title={"分類借閱佔比"}
                        extra={"各分類借閱量的百分比分布"}
                    >
                        <ChartCategoryBorrowRatio />
                    </Card>
                </Col>
            </Row>
        </Col>
        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
            <Card
                title={"分類月度趨勢"}
                extra={"各分類時段的借閱趨勢變化"}
            >
                <ChartCategoryMonthlyTrend />
            </Card>
        </Col>
        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
            <Card title={"分類流通詳細資料"} >
                <TableCategoryCirculationDetails />
            </Card>
        </Col>
    </Row>)
}
export { CirculationTrendAnalysis }